export const fetchSurveyQuestionsTypes = [
  'FETCH_SURVEY_QUESTIONS',
  'FETCH_SURVEY_QUESTIONS_SUCCESS',
  'FETCH_SURVEY_QUESTIONS_FAIL',
];

export const addSurveyQuestionTypes = [
  'ADD_SURVEY_QUESTION',
  'ADD_SURVEY_QUESTION_SUCCESS',
  'ADD_SURVEY_QUESTION_FAIL',
];

export const updateSQuestionTypes = [
  'UPDATE_S_QUESTION',
  'UPDATE_S_QUESTION_SUCCESS',
  'UPDATE_S_QUESTION_FAIL',
];

// export const addSQuestionOptionTypes = [
//   'ADD_S_QUESTION_OPTION',
//   'ADD_S_QUESTION_OPTION_SUCCESS',
//   'ADD_S_QUESTION_OPTION_FAIL',
// ];
//
// export const removeSQuestionOptionTypes = [
//   'REMOVE_S_QUESTION_OPTION',
//   'REMOVE_S_QUESTION_OPTION_SUCCESS',
//   'REMOVE_S_QUESTION_OPTION_FAIL',
// ];
//
export const removeSQuestionTypes = [
  'REMOVE_S_QUESTION',
  'REMOVE_S_QUESTION_SUCCESS',
  'REMOVE_S_QUESTION_FAIL',
];



// WEBPACK FOOTER //
// ./src/modules/survey/action_types.js